module.exports = __webpack_public_path__ + "img/icon_bell_white.fb819709.svg";